import { memo } from 'react'
import { GeoJSON } from 'react-leaflet'

import {
  LayerMap,
  MergedLayerMap,
} from '@/hooks/queries/use-get-infestation-from-diagnosis'
import { applyBufferInGeoJSON } from '@/pages/diagnosis-view/utils/geojson'

interface WeedMapProps {
  layersMap: LayerMap[]
  mergedLayersMap: MergedLayerMap[]
  shouldShowBuffer: boolean
  isPulverization: boolean
}

const InfestationLayersComponent = ({
  layersMap,
  mergedLayersMap,
  shouldShowBuffer,
  isPulverization,
}: WeedMapProps) => {
  const infestationLayers = layersMap.map((layer) => {
    if (layer.removed) return

    const currentLayer = layer.mergedName
      ? mergedLayersMap.find(
          (mergedLayer) => mergedLayer.name === layer.mergedName,
        )
      : layer

    const geoJsonProps = {
      key: `${layer.name}-${layer.mergedName}-buffer:${currentLayer?.buffer}(${currentLayer?.buffered},${shouldShowBuffer})`,
      data:
        shouldShowBuffer && currentLayer?.buffered
          ? applyBufferInGeoJSON(layer.diagnosis, currentLayer?.buffer)
          : layer.diagnosis,
      style: {
        color: currentLayer?.colorPalette,
        fillOpacity: layer.mergedName ? 1 : 0.2,
        fill: isPulverization ? true : !!layer.fillColor,
        weight: 1,
        fillRule: 'nonzero' as const,
      },
    }
    return <GeoJSON {...geoJsonProps} key={geoJsonProps.key} />
  })

  return <>{infestationLayers}</>
}

export const InfestationLayers = memo(InfestationLayersComponent)
